import i18n from '@/helpers/i18n'

export default {
  install(Vue) {
    Vue.prototype.$getLocalizedUrl = (key) => i18n.getLocalizedUrl(key)
  }
}
